

































export default

	props:
		product: Object
		currentVariant: Object

	computed:

		# Make the brand slug
		brand: -> if @product.vendor?.match /lucini/i then 'lucini' else 'cor'

		bundleImages: ->
			images = []
			images.push(@currentVariant.image)
			return images

